export const mxn = (v) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency", currency: "MXN",
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(Number(v || 0));

export const numfmt = (v) =>
  new Intl.NumberFormat("es-MX", { maximumFractionDigits: 2 }).format(Number(v || 0));

/** Formato de captura de MONTOS: agrega separador de miles (comas) a un valor crudo
 *  mientras el usuario teclea, preservando el punto decimal y los decimales en curso.
 *  Es SOLO presentación: el valor crudo (sin comas) es lo que se guarda/calcula.
 *  Ej: "10000" → "10,000"; "1250000.5" → "1,250,000.5"; "10000." → "10,000.". */
export const formatMoneyInput = (raw) => {
  if (raw === "" || raw == null) return "";
  const s = String(raw);
  const [intPart, decPart] = s.split(".");
  const intFmt = (intPart || "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return s.includes(".") ? `${intFmt}.${decPart ?? ""}` : intFmt;
};

/** Quita las comas de presentación y devuelve el valor crudo (dígitos y un punto).
 *  Acepta hasta 2 decimales. Cadena vacía si queda vacío. */
export const parseMoneyInput = (display) => {
  if (display == null) return "";
  return String(display).replace(/,/g, "");
};

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const fdate = (v) => {
  if (!v) return "—";
  const s = String(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]} ${MESES[parseInt(m[2], 10) - 1]} ${m[1]}`;
  try {
    const d = new Date(s);
    return `${String(d.getDate()).padStart(2, "0")} ${MESES[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return s;
  }
};

export const fdatetime = (v) => {
  if (!v) return "—";
  try {
    const d = new Date(v);
    return `${fdate(v)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  } catch {
    return String(v);
  }
};

export const boolText = (v) => (v ? "Sí" : "No");

// Unidades por periodicidad para el fraseo corto del plazo ("12 meses").
// Espejo backend: /app/backend/catalogos_maestros.py::formatear_plazo
const PLAZO_UNIDADES = {
  semanal: ["semana", "semanas"],
  quincenal: ["quincena", "quincenas"],
  mensual: ["mes", "meses"],
  diaria: ["día", "días"],
  catorcenal: ["catorcena", "catorcenas"],
  bimestral: ["bimestre", "bimestres"],
  trimestral: ["trimestre", "trimestres"],
};

/** Fraseo corto único del plazo: (12, "Mensual") → "12 meses". Sin plazo → "—".
 *  Periodicidad desconocida → "N pagos" (no inventa unidad). */
export const formatearPlazo = (plazo, periodicidad) => {
  const n = Number(plazo);
  if (!Number.isFinite(n) || n <= 0) return "—";
  const u = PLAZO_UNIDADES[String(periodicidad || "").trim().toLowerCase()];
  if (!u) return `${n} pagos`;
  return `${n} ${n === 1 ? u[0] : u[1]}`;
};

const PERIODICIDAD_PAGOS = {
  semanal: "pagos semanales",
  quincenal: "pagos quincenales",
  mensual: "pagos mensuales",
  diaria: "pagos diarios",
  catorcenal: "pagos catorcenales",
  bimestral: "pagos bimestrales",
  trimestral: "pagos trimestrales",
};

/** Leyenda de la periodicidad para labels: "Mensual" → "pagos mensuales". */
export const etiquetaPeriodicidad = (periodicidad) =>
  PERIODICIDAD_PAGOS[String(periodicidad || "").trim().toLowerCase()] || "pagos";
